import React, { useEffect, useRef } from 'react';
import OurPrograms from './programs_pages/OurPrograms';
import Footer from '../../../components/Footer';

const Programs = ({ setNavigateToSection }) => {
  return (
    <div>
      <OurPrograms />
      <Footer setNavigateToSection={setNavigateToSection} />
    </div>
  );
};

export default Programs;
